const isActiveClass = 'is-active'
const faqOpenerClass = 'image-faq__opener'
const faqBodyContentClass = 'image-faq__body-content'

document.addEventListener('DOMContentLoaded', () => {
  const imageFaqOpeners = document.getElementsByClassName(faqOpenerClass)

  for (const imageFaqOpener of imageFaqOpeners) {
    imageFaqOpener.addEventListener('click', () => {
      const bodyContent = document.querySelector(`.image-faq__body-content[data-faq-id="${imageFaqOpener.dataset.faqId}"]`)

      // We open only, no click toggles a close
      if (
        imageFaqOpener.classList.contains(isActiveClass) ||
        typeof bodyContent == 'undefined'
      ) return

      // reset all active FAQ's
      const componentRoot = imageFaqOpener.closest('.image-faq')
      const activeItems = componentRoot.querySelectorAll('.' + isActiveClass)
      for (const activeItem of activeItems) {
        activeItem.classList.remove(isActiveClass)
        activeItem.setAttribute('aria-expanded', false)
      }

      // Reset all plus and minus icons
      const plusIcons = componentRoot.getElementsByClassName('icon-faq-plus')
      const minusIcons = componentRoot.getElementsByClassName('icon-faq-minus')
      for (const plusIcon of plusIcons) {
        plusIcon.setAttribute('aria-hidden', false)
      }

      for (const minusIcon of minusIcons) {
        minusIcon.setAttribute('aria-hidden', true)
      }

      // Class these suckers
      const faqImage = document.querySelector(
        `.faq-images__image-container[data-faq-id="${imageFaqOpener.dataset.faqId}"]`
      )

      faqImage.classList.add(isActiveClass)
      imageFaqOpener.classList.add(isActiveClass)
      imageFaqOpener.setAttribute('aria-expanded', true)
      bodyContent.classList.add(isActiveClass)
      bodyContent.setAttribute('aria-expanded', true)

      const thisPlusIcon = imageFaqOpener.querySelector(".icon-faq-plus")
      const thisMinusIcon = imageFaqOpener.querySelector(".icon-faq-minus")
      thisPlusIcon.setAttribute('aria-hidden', true)
      thisMinusIcon.setAttribute('aria-hidden', false)
    })
  }
})
